import React from 'react';
export function Footer() {
  return <footer className="defer-paint w-full border-t border-line bg-navy pb-24 pt-10 sm:pb-10" data-id="element-91" data-mp="32wd0e9mw79qd">
      <div className="mx-auto max-w-5xl px-6 text-center" data-id="element-92" data-mp="3gg0xpz2xhpvj">
        <p className="font-display text-2xl font-extrabold uppercase tracking-[0.12em] text-fg" data-id="element-93" data-mp="32oe3e4sjqrfe">
          Futsal <span className="text-accent" data-id="element-94" data-mp="36oy0j8d4dv1j">360</span> Ready™
        </p>
        <p className="mt-2 font-display text-sm font-bold uppercase tracking-[0.24em] text-muted" data-id="element-95" data-mp="36n3c3k2n3ksp">
          Open → Choose → Set up → Coach
        </p>
        <div className="mx-auto mt-6 h-px w-16 bg-accent/50" aria-hidden="true" data-id="element-96" data-mp="37o38m5zzh95" />
        <p className="mt-6 text-sm leading-relaxed text-muted" data-id="element-97" data-mp="3lf582t1l9tng">
          © 2026 FUTSAL 360 READY™ — All rights reserved.
        </p>
        <p className="mt-1 text-sm text-muted" data-id="element-98" data-mp="3qbvo5gde8p8v">
          Digital coaching system for futsal coaches.
        </p>
        <p className="mx-auto mt-3 max-w-xl text-xs leading-relaxed text-muted" data-id="element-99" data-mp="2a19u3nmf7qxt">
          Results depend on how the system is applied in real training
          environments.
        </p>
      </div>
    </footer>;
}